export function formatToPattern(mask: string, value: string) {
  let r = '';
  for (let im = 0, is = 0; im < mask.length && is < value.length; im++) {
    r += mask.charAt(im) == 'X' ? value.charAt(is++) : mask.charAt(im);
  }
  return r;
}
